export default __webpack_public_path__ + "static/media/DSCN0381.a5eba0a5.JPG";